import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { TranslatePipe, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/manual/i18n/scope";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-task-update-task-document-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe, TranslatePipe],
    viewProviders: [provideTranslationScope(scope)],
})
export class TaskUpdateTaskDocumentApiManualV2Component extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: this.translation.t("tableOfContents.addDocumentToTask"),
            description: this.translation.t("specs.addDocumentToTaskDescription"),
            httpMethod: "POST",
            path: "/taskdata/v2/tasks/{guid}/add/document",

            parameters: [
                {
                    name: "guid",
                    description: this.translation.t("parameters.addDocumentToTaskGuidDescription"),
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "document",
                    description: this.translation.t("parameters.addDocumentToTaskDocumentDescription"),
                    in: "file",
                    paramType: "formData",
                    required: true,
                    example: "binary",
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                },
            ],
        };
    }
}
